import React, { useEffect, useState } from "react";
import axios from "axios";
import Slider from "react-slick";
import Loading from "../../PrivacyPolicy/Loading";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa"; // Import arrow icons
import image from "../../../assets/icons/testing.png"
import { useLanguage } from "../../../store/language-context";
import { useTranslation } from "react-i18next";

const Licenses = () => {
  const { t } = useTranslation();
  const [dataItems, setDataItems] = useState([]);
  const { URL } = useLanguage();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${URL}/home-pages?title_section=licenses`
        );
        if (response.data.status === 200) {
          const fetchedData = Array.isArray(response.data.data.data)
            ? response.data.data.data
            : [response.data.data.data]; // Ensure it's an array
          setDataItems(fetchedData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [URL]);

  if (dataItems.length === 0) {
    return (
      <div className="">
        <Loading />
      </div>
    );
  }

  // Slick Slider settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,

    autoplaySpeed: 3000,

    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 776,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="container">
      <section className="quality-container licenses ">
        <h2 className="section-title ">
          {t('about.licenses')} 
        </h2>

        <Slider {...settings} className="quality-slider pt-4 w-100">
          {dataItems.map((item, index) =>
            item ? (
              <div key={index} className="quality-slide w-100 ">

                <div className="licenses w-100 ">

                  {item.image ? (
                    <a href={item.image} target="_blank" rel="noopener noreferrer">
                      <img src={item.image} alt={item.title} className="h-100 lince-img" />
                    </a>
                    // <img src={image} alt={item.title} className="h-100" />
                  ) : (
                    <div className="">
                      No Image Available
                    </div>
                  )}

                </div>
              </div>
            ) : null
          )}
        </Slider>
      </section>
    </div>
  );
};

// Custom Next Arrow
// Custom Next Arrow
const NextArrow = ({ onClick }) => {
  return (
    <div
      className="slick-arrow slick-next"

      onClick={onClick}
    >
      <FaChevronRight size={20} />
    </div>
  );
};

// Custom Prev Arrow
const PrevArrow = ({ onClick }) => {
  return (
    <div
      className="slick-arrow slick-prev"
      onClick={onClick}
    >
      <FaChevronLeft size={20} />
    </div>
  );
};

export default React.memo(Licenses);